export default {
    label_task:{
        en:"Part Numbers",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Part Number",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Part Number",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Part Number",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
    label_description:{
        en:"Description",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_description_additional:{
        en:"Additional Description",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_note:{
        en:"Note",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_vendor1_name:{
        en:"Vendor 1",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_vendor2_name:{
        en:"Vendor 2",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_vendor3_name:{
        en:"Vendor 3",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}